import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { useAuthService } from 'theme/services/auth/auth-service'
import Layout from 'src/components/core/uxdx/layout'
import MetaData from 'src/components/core/metaData'
import Sessions from 'src/components/person/sessions'
import { getTwitterHandle, getTwitterUrl } from 'theme/utils/social-helpers'
import { Remarkable } from 'remarkable'

const PersonPage = ({ data }) => {
  const md = new Remarkable({ breaks: true })
  const authService = useAuthService()
  const user = authService.user

  const person = data.person
  const personName = person.data.Person_First + ' ' + person.data.Person_Last
  const profilePicUrl = person.data.Profile_Picture_Url_250

  const company =
    person.data.Person_Company && person.data.Person_Company[0] && person.data.Person_Company[0].data
  const companyName = company && company.Company_Name
  const companyLogoExists = company && company.Company_Logo_Url
  const companyUrl = company && company.Company_Url

  const filteredSessions = person.data.Sessions
    ? person.data.Sessions.filter((session) => {
        // const currentTime = new Date()
        // const fourYearsAgo = new Date(2018, 0, 1)
        // const sessionStartTime = new Date(session.data.Session_Start_time)
        return (
          ['Published'].indexOf(session.data.Session_Status) !== -1 &&
          session.data.Organisation.includes('UXDX') &&
          (session.data.Conference_Status?.includes('Published') || session.data.Video)
        )
      })
    : []

  const sortedSessions = filteredSessions.sort(
    (a, b) => new Date(b.data.UTC_Start_Time).getTime() - new Date(a.data.UTC_Start_Time).getTime(),
  )

  const articles = []
  // const articles = data.articles.nodes.map((post) => {
  //   const ghostPost = data.ghostArticles.edges.find((ghostPost) => {
  //     return ghostPost.node.slug === post.data.Ghost_Slug
  //   })
  //   if (ghostPost && ghostPost.node) {
  //     post.data.title = ghostPost.node.title
  //     post.data.feature_image = ghostPost.node.feature_image
  //     post.data.feature_image_sharp = ghostPost.node.feature_image_sharp
  //     post.data.excerpt = ghostPost.node.excerpt
  //   }

  //   return post
  // })

  return (
    <Layout>
      <MetaData
        keywords={[
          'uxdx',
          'product',
          'ux',
          'design',
          'dev',
          'agile',
          personName,
          person.data.jobTitle,
          companyName,
        ]}
        title={personName}
        description={'A list of the talks and articles that ' + personName + ' has delivered at UXDX'}
        image={person.data.Meta_Image_Url}
        type="profile"
      />
      <section className="max-w-screen-xl mb-12 mt-10 m-auto px-2">
        <div>
          <div className="flex justify-center flex-wrap sm:flex-nowrap max-w-3xl m-auto">
            {profilePicUrl ? (
              // <GatsbyImage
              //   image={profilePicUrl}
              //   alt={personName}
              //   className="h-full w-64 object-cover rounded-lg"
              // />
              <img
                src={profilePicUrl}
                alt={personName}
                className="h-full w-64 object-cover rounded-lg bg-gradient-to-r from-blue-200 to-violet-100"
              />
            ) : null}
            <div className="flex flex-col justify-between text-left p-4 sm:ml-8">
              <div>
                <h1 className="text-4xl pb-2">{personName}</h1>
                <div className="flex">
                  {person.data.Person_Linkedin && (
                    <a
                      className="text-base mb-2 mr-5"
                      target="blank"
                      rel="noreferrer nofollow"
                      href={person.data.Person_Linkedin}
                    >
                      <svg className="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6s9.6-4.298,9.6-9.6S15.302,0.4,10,0.4z M7.65,13.979 H5.706V7.723H7.65V13.979z M6.666,6.955c-0.614,0-1.011-0.435-1.011-0.973c0-0.549,0.409-0.971,1.036-0.971s1.011,0.422,1.023,0.971 C7.714,6.52,7.318,6.955,6.666,6.955z M14.75,13.979h-1.944v-3.467c0-0.807-0.282-1.355-0.985-1.355 c-0.537,0-0.856,0.371-0.997,0.728c-0.052,0.127-0.065,0.307-0.065,0.486v3.607H8.814v-4.26c0-0.781-0.025-1.434-0.051-1.996h1.689 l0.089,0.869h0.039c0.256-0.408,0.883-1.01,1.932-1.01c1.279,0,2.238,0.857,2.238,2.699V13.979z"
                        />
                      </svg>
                    </a>
                  )}
                  {person.data.Person_Twitter && (
                    <a
                      className="text-base mb-2 flex items-center"
                      target="blank"
                      rel="noreferrer nofollow"
                      href={getTwitterUrl(person.data.Person_Twitter)}
                    >
                      <svg className="h-7 w-7" fill="#1DA1F2" viewBox="0 0 24 24">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                      </svg>
                      {getTwitterHandle(person.data.Person_Twitter)}
                    </a>
                  )}
                </div>
                <p className="text-md">{person.data.Person_Job_Title}</p>
                {companyUrl && (
                  <a href={companyUrl} rel="noreferrer noopener" target="_blank">
                    <p className="text-md font-bold">{companyName}</p>
                  </a>
                )}
                {!companyUrl && <p className="text-md font-bold">{companyName}</p>}
              </div>
              <div className="mt-4 max-h-8">
                {companyLogoExists && !companyUrl && (
                  <img src={company.Company_Logo_Url} alt={companyName} className="h-8 object-scale-down" />
                )}
                {companyLogoExists && companyUrl && (
                  <a href={companyUrl} rel="noreferrer noopener" target="_blank">
                    <img src={company.Company_Logo_Url} alt={companyName} className="h-8 object-scale-down" />
                  </a>
                )}
              </div>
            </div>
          </div>
          {person.data.Person_Bio && (
            <div
              className="text-md max-w-3xl m-auto pt-8"
              dangerouslySetInnerHTML={{
                __html: md.render(person.data.Person_Bio),
              }}
            />
          )}
        </div>
      </section>
      <Sessions user={user} sessions={sortedSessions} person={data.person} articles={articles} />
    </Layout>
  )
}

PersonPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default PersonPage

// europe 2020 conference id bfb0f47e-2e52-5532-9324-b447b443fa73
export const postQuery = graphql`
  query ($id: String!) {
    person: airtablePeople(id: { eq: $id }) {
      id
      data {
        Person_First
        Person_Last
        Person_Job_Title
        Person_Twitter
        Person_Linkedin
        Person_Bio
        Person_Url_Slug
        Meta_Image_Url
        Person_Company {
          data {
            Company_Name
            Company_Logo_Url
            Company_Url
            Company_Twitter
          }
        }
        Profile_Picture_Url_50
        Profile_Picture_Url_250
        Sessions {
          id
          recordId
          data {
            Talk_Title
            Talk_Description
            UTC_Start_Time
            UTC_End_Time
            Session_Slug
            Calendar_Id
            Capacity
            Video
            Mux_Video
            Always_Display_on_Speaker_Page
            Session_Status
            Session_Slug
            Conference_Status
            Organisation
            Conference {
              data {
                Conference_Id
                Conference_Name
                Location
                Year
                Type
                Organisation
                Conference_Venue_Type
              }
            }
            Speakers {
              id
              data {
                Person_Job_Title
                Person {
                  id
                  data {
                    Person_First
                    Person_Last
                    Person_Twitter
                    Person_Url_Slug
                    Person_Status
                    Person_Linkedin
                    Hide_Speaker
                    Person_Priority
                    Profile_Picture_Url_50
                    Profile_Picture_Url_250
                  }
                }
                Company {
                  data {
                    Company_Name
                    Company_Logo_Url
                  }
                }
              }
            }
            Session_Groups {
              data {
                Group
                Requires_Register
                Recordings_Available
                Requires_Stage
                Format_Description
                Delivery_Description
                Job
                Delivery
                Format
                Location
                Location_Description
              }
            }
            Stream {
              data {
                Stream_Name
              }
            }
            Stage {
              data {
                Stage_Name
                Stage_Colour
              }
            }
          }
        }
      }
    }
  }
`

// articles: allAirtableBlog(
//   filter: { data: { Author: { elemMatch: { id: { eq: $id } } } } }
//   sort: { data: { Release_Date: DESC } }
// ) {
//   nodes {
//     data {
//       Type
//       Ghost_Slug
//       Release_Date
//       Author {
//         data {
//           Person_Last
//           Person_First
//           Person_Job_Title
//           Person_Url_Slug
//           Person_Company {
//             data {
//               Company_Name
//             }
//           }
//           Profile_Picture_Url_50
//           Profile_Picture_Url_250
//         }
//       }
//     }
//   }
// }
// ghostArticles: allGhostPost {
//   edges {
//     node {
//       id
//       slug
//       title
//       feature_image
//       feature_image_sharp {
//         childImageSharp {
//           gatsbyImageData(width: 800, quality: 80, layout: CONSTRAINED, formats: [AUTO, WEBP])
//         }
//       }
//       excerpt
//       published_at
//       authors {
//         id
//         slug
//       }
//     }
//   }
// }
